module.exports = __webpack_public_path__ + "static/media/arcnet-logo-blue.b13f9729.svg";